import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 439.21 113.39"
    >
      <g id="logo_classic">
        <g id="logo_classic_bg_rgb">
          <path
            d="M146.14,67.85v14.25h-9.68v-41.58h16.88c4.93,0,8.84,1.26,11.74,3.78,2.9,2.52,4.34,5.82,4.34,9.9s-1.45,7.39-4.34,9.9c-2.89,2.5-6.81,3.75-11.74,3.75h-7.2ZM146.14,60.43h7.2c2.09,0,3.69-.57,4.78-1.73,1.09-1.15,1.64-2.63,1.64-4.44s-.55-3.36-1.64-4.54c-1.09-1.18-2.69-1.77-4.78-1.77h-7.2v12.48Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M207.6,40.52v27.25c0,4.74-1.58,8.42-4.73,11.03-3.15,2.61-7.28,3.91-12.38,3.91s-9.32-1.3-12.48-3.91c-3.16-2.61-4.74-6.28-4.74-11.03v-27.25h9.68v27.25c0,2.55.66,4.44,1.97,5.67,1.31,1.23,3.17,1.84,5.57,1.84s4.21-.61,5.5-1.83c1.29-1.22,1.93-3.11,1.93-5.68v-27.25h9.68Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M223.28,74.68h18.94v7.42h-30.82v-4.34l18.59-29.82h-18.68v-7.43h30.64v4.17l-18.68,29.99Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M257.12,74.68h18.93v7.42h-30.81v-4.34l18.59-29.82h-18.68v-7.43h30.64v4.17l-18.68,29.99Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M289.36,74.68h17.91v7.42h-27.59v-41.58h9.68v34.16Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M336.61,64.31h-16.31v10.37h19.22v7.42h-28.9v-41.58h28.96v7.43h-19.28v8.94h16.31v7.43Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M368.73,82.1h-9.62v-41.58h9.62v41.58Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M403.87,47.95h-10.97v34.16h-9.68v-34.16h-10.88v-7.43h31.53v7.43Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M439.1,67.51l.06.17c-.19,4.88-1.63,8.6-4.33,11.17-2.7,2.57-6.6,3.85-11.72,3.85s-9.32-1.58-12.54-4.74c-3.22-3.16-4.83-7.26-4.83-12.31v-8.68c0-5.03,1.55-9.12,4.64-12.29,3.09-3.17,7.11-4.76,12.07-4.76,5.25,0,9.27,1.32,12.05,3.97,2.78,2.65,4.35,6.41,4.71,11.28l-.06.17h-9.4c-.13-2.7-.74-4.71-1.81-6.03-1.08-1.31-2.91-1.97-5.5-1.97-2.19,0-3.91.88-5.17,2.64-1.25,1.76-1.88,4.07-1.88,6.93v8.74c0,2.88.69,5.2,2.06,6.97,1.37,1.77,3.25,2.66,5.65,2.66s3.97-.62,4.94-1.86c.97-1.24,1.52-3.21,1.65-5.91h9.4Z"
            fill="#fff"
            strokeWidth="0"
          />
          <path
            d="M96.78,16.6c-22.14-22.14-58.04-22.14-80.17,0-22.14,22.14-22.14,58.04,0,80.18,22.14,22.14,58.04,22.14,80.17,0,22.14-22.14,22.14-58.03,0-80.18ZM92.41,36.18c-1.85,5.52-7.79,22.07-7.79,22.07-1.99,5.39-13.62,5.35-29.41,5.39,0,0,10.2-1.44,13.15-7.14,2.95-5.69,6.42-17.23,6.42-17.23-15.71,0-17.11,5.5-17.11,5.5,0,0-9.93,27.77-13.47,38.01-27.51,0-23.12-13.59-23.12-13.59l13.76-38.61h27.88l-1.86,5.56s2.27-5.56,17.64-5.56c0,0,15.75.07,13.9,5.59Z"
            fill="#fff"
            strokeWidth="0"
          />
        </g>
      </g>
    </svg>
  );
};

export default LogoFull;
